module.exports = __webpack_public_path__ + "assets/img/tag-star-jade-8197b0af.png";